import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bosch-ui-info-field',
  imports: [CommonModule],
  templateUrl: './bosch-ui-info-field.component.html',
  styleUrls: ['./bosch-ui-info-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiInfoFieldComponent {
  @Input() label: string | null = null;
  @Input() text: string | null = null;
}
